import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u757177604/domains/plotae.com/hbuilds/source/src/components/templates/AboutTemplate.tsx");
